import setRuleForSelector from './set-rule-for-selector';

const copyCssTextForBlock = (sourceBlockId, targetBlockId, customStylesheet) => {
  const { cssRules } = customStylesheet;

  Object.values(cssRules).forEach((rule) => {
    const {
      selectorText,
      style: { cssText: blockRule },
    } = rule;

    if (selectorText.startsWith(`#${sourceBlockId}`)) {
      setRuleForSelector(
        selectorText.replace(sourceBlockId, targetBlockId),
        customStylesheet,
        blockRule
      );
    }
  });
};

export default copyCssTextForBlock;
